module.exports = __webpack_public_path__ + "static/img/buy_zh.f6d4c987.png";